import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { BreadcrumbsWrapper, Grid, Typography, units } from '@hbf/dsl';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';

import { ListingAddressIcon } from './ListingAddressIcon';
import { ListingBreadcrumbs } from '../fragments/ListingBreadcrumbs';

const useStyles = makeStyles()({
  text: {
    // this is to fix alignment of text to icon due to whitespace above text
    marginTop: '-1px',
    marginLeft: units.rem(0.25),
  },
  addressTitle: {
    cursor: 'pointer',
  },
});

interface Props {
  street: string;
  city: string;
  country: string;
  isMapAvailable: boolean;
  onAddressClick?: () => void | undefined;
  showBreadcrumbs?: boolean;
}

const withTrackEvent = (Component: React.ReactNode) => (
  <Track name="Clicked Map marker anchor" type="link">
    {Component}
  </Track>
);

const ListingAddress: React.FC<Props> = ({
  street,
  city,
  country,
  isMapAvailable,
  onAddressClick,
  showBreadcrumbs,
}) => {
  const { classes } = useStyles();

  const Address = React.useMemo(() => {
    let AddressElement = (
      <span
        data-test-locator="Listing address title"
        className={classes.addressTitle}
        onClick={isMapAvailable && onAddressClick ? onAddressClick : undefined}
      >
        <Grid container direction="row">
          <Grid item>
            <ListingAddressIcon />
          </Grid>
          <Grid item className={classes.text}>
            <Typography.Paragraph color="muted">{`${city}, ${country}`}</Typography.Paragraph>
          </Grid>
        </Grid>
      </span>
    );

    if (isMapAvailable) {
      AddressElement = withTrackEvent(AddressElement);
    }

    return AddressElement;
  }, [
    city,
    classes.addressTitle,
    classes.text,
    country,
    isMapAvailable,
    onAddressClick,
  ]);

  return (
    <Grid container direction="column" justifyContent="center">
      <Grid item>
        <Typography.H1>{street}</Typography.H1>
      </Grid>
      <Grid item>
        {showBreadcrumbs ? (
          <BreadcrumbsWrapper elevation={0} padLeft={false} padBottom={false}>
            <ListingBreadcrumbs />
          </BreadcrumbsWrapper>
        ) : (
          Address
        )}
      </Grid>
    </Grid>
  );
};

export { ListingAddress };
